import * as R from 'ramda'

export const validateEmtpyValueFormsy = (values, value) => {
  return R.compose(
    R.not,
    R.anyPass([R.isNil, R.isEmpty]),
    R.unless(R.isNil, R.trim),
  )(value)
}
